'use client';

import { useTranslations } from 'next-intl';
import { RING_PRO_US_STATS_DISCLAIMER_ID } from 'utils/ringProUsBatteryDisclaimer';
import styles from './RingProUsStatsDisclaimer.module.css';

/** Battery footnote — last block on the US homepage, above the site footer. */
export const RingProUsStatsDisclaimer = () => {
  const t = useTranslations('homepage');

  return (
    <aside
      className={styles.wrap}
      aria-label={t('homepage.ringProUs.stats.disclaimerAria')}
    >
      <div id={RING_PRO_US_STATS_DISCLAIMER_ID} className={styles.inner}>
        <p className={styles.text}>
          {t('homepage.ringProUs.stats.disclaimer')}
        </p>
      </div>
    </aside>
  );
};

export default RingProUsStatsDisclaimer;
